import apiClient from '../axios.js'

/**
 * 平台管理 API（管理平台本身，非平台帳號）
 */
export const platformManagementService = {
    /**
     * 獲取平台列表
     * @param {Object} params - 查詢參數
     * @param {number} params.page - 頁碼
     * @param {number} params.pageSize - 每頁數量
     * @param {string} params.search - 搜尋關鍵字
     * @returns {Promise<Object>} 平台列表
     */
    getPlatforms: async (params = {}) => {
        const response = await apiClient.get('/system/platforms/management', { params })
        return response
    },

    /**
     * 獲取單一平台詳情
     * @param {string} id - 平台 ID
     * @returns {Promise<Object>} 平台詳情
     */
    getPlatform: async (id) => {
        const response = await apiClient.get(`/system/platforms/management/${id}`)
        return response
    },

    /**
     * 新增平台
     * @param {Object} platformData - 平台資料
     * @param {string} platformData.platformCode - 平台代碼
     * @param {string} platformData.platformName - 平台名稱
     * @param {string} platformData.status - 狀態（可選，預設 active）
     * @param {string} platformData.planType - 方案類型（可選）
     * @param {number} platformData.maxClients - 客戶數上限（可選，預設 10）
     * @returns {Promise<Object>} 新增結果
     */
    createPlatform: async (platformData) => {
        const response = await apiClient.post('/system/platforms/management', platformData)
        return response
    },

    /**
     * 更新平台
     * @param {string} id - 平台 ID
     * @param {Object} platformData - 平台資料
     * @returns {Promise<Object>} 更新結果
     */
    updatePlatform: async (id, platformData) => {
        const response = await apiClient.put(`/system/platforms/management/${id}`, platformData)
        return response
    },

    /**
     * 刪除平台
     * @param {string} id - 平台 ID
     * @returns {Promise<Object>} 刪除結果
     */
    deletePlatform: async (id) => {
        const response = await apiClient.delete(`/system/platforms/management/${id}`)
        return response
    },
}

/**
 * 平台管理 API（用於下拉選單等簡單查詢）
 */
export const platformService = {
    /**
     * 獲取平台列表（簡單查詢，用於下拉選單）
     * @param {Object} params - 查詢參數
     * @returns {Promise<Object>} 平台列表
     */
    getPlatforms: async (params = {}) => {
        const response = await apiClient.get('/system/platforms/management', { params })
        return response
    },
}
